import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter
} from '@angular/core';
import * as moment from 'moment-timezone';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AppointmentService } from '@app/shared/services/appointment.service';
import { ModalDirective } from 'ngx-bootstrap';
@Component({
  selector: 'app-group-call-schedule',
  templateUrl: './group-call-schedule.component.html',
  styleUrls: ['./group-call-schedule.component.scss'],
  exportAs: 'GroupCallScheduleModal'

})
export class GroupCallScheduleComponent implements OnInit {

  // @ViewChild('GroupCallScheduleModal', { static: false })
  @ViewChild('GroupCallScheduleModal') public GroupCallScheduleModal: ModalDirective;

  @Output() refreshAPI: EventEmitter<any> = new EventEmitter();
  bsDateValue = new Date();
  minimumDate = new Date();
  selectedTable: any;
  scheduleDetails: any = {};
  slotValue: any;
  message: string;
  showCustomError = false;
  userRole: string;
  analystName: string;
  bookNow: boolean;
  availableSlots = [];
  value: Date;
  hideBookNowBtn: boolean;
  serviceProviderIds = [];
  projectId: string;
  constructor(private toastr: ToastrService, private appointmentService: AppointmentService, private router: Router) {
    this.value = new Date();
    this.hideBookNowBtn = false;
  }

  ngOnInit() {
    this.getServiceProviderList();
  }
  getServiceProviderList() {
    this.appointmentService.getScheduleCallSPDetails(this.projectId).subscribe(
      (data) => {
        this.serviceProviderIds = [];
      }, err => {

      }
    );
  }
  showModal(projectId): void {
    this.projectId = projectId;
    this.initializeModal();
    this.GroupCallScheduleModal.show();
  }

  hideModal(): void {
    this.GroupCallScheduleModal.hide();
  }
  initializeModal() {
    this.showCustomError = false;
    this.bookNow = true;
    this.value = new Date();
  }
  getCommonAvailableSlots() {
    // this.projectId = projectId;
    // todo call API to get service providers of project
    this.showCustomError = false;
    const timeNow = new Date();
    const timezone = 'UTC' + moment().format('Z');
    const data = {
      serviceProviderIds: this.serviceProviderIds,
      timeZone : timezone,
      date: moment(this.value).format('YYYY-MM-DD')
    };
    this.appointmentService.getCommonAvailableSlots(data).subscribe(
      (response => {
        this.scheduleDetails = response;
        // this.scheduleDetails.id = this.serviceProviderIds;
        this.availableSlots = this.scheduleDetails.filter((slot) => {
          const target = new Date(slot.start.dateTime);
          if (target > timeNow) {
            slot.start.dateTime = moment.parseZone(slot.start.dateTime).local().format();
            slot.end.dateTime = moment.parseZone(slot.end.dateTime).local().format();
            return slot;
          }
        });
        this.availableSlots = _.sortBy(this.availableSlots, [(data: any) => data.start.dateTime]);
        if (this.availableSlots.length > 0) {
          this.slotValue = this.availableSlots[0];
        } else {
          this.slotValue = {};
        }
        this.GroupCallScheduleModal.show();
      }),
      error => {
        this.toastr.error(error.error.error.message, ' Error');
      }
    );
  }
  bookProjectGroupCall(projectId) {
    this.showCustomError = false;
    this.bookNow = false;
    this.hideBookNowBtn = true;
    const timeSlots = _.cloneDeep(this.slotValue);
    if (this.slotValue.start && this.slotValue.end.dateTime) {
      timeSlots.start.dateTime = moment.utc(this.slotValue.start.dateTime).format('YYYY-MM-DDTHH:mm:00.000000');
      timeSlots.end.dateTime = moment.utc(this.slotValue.end.dateTime).format('YYYY-MM-DDTHH:mm:00.000000');
      const requestData = {
        bookingData: {
          slot: timeSlots,
          message: this.message
        },
        serviceProviderIds: this.serviceProviderIds,
        projectId: this.projectId
      };
      if (this.slotValue.start && this.slotValue.end) {
        this.appointmentService.scheduleGroupCall(requestData).subscribe(
          data => {
            this.hideBookNowBtn = false;
            this.GroupCallScheduleModal.hide();
            this.toastr.success('Call has been scheduled successfully', 'Success');
            this.router.navigateByUrl(`app/meetings`);
          }, err => {
            this.hideBookNowBtn = false;
            this.toastr.error(err.error.message, 'Error');
          }
        );
      }
    } else {
      this.hideBookNowBtn = false;
      this.toastr.error('Please select a time slot', 'Error');
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/layout/group-call-schedule/group-call-schedule.component.ts